import { render, staticRenderFns } from "./ViewQA.vue?vue&type=template&id=1ff0eabe&"
import script from "./ViewQA.vue?vue&type=script&lang=js&"
export * from "./ViewQA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports